<div class="container container_type_main">
  <div class="subtitle h2 mt-32">{{ 'subscriber-favorites-page.title' | translate }}</div>

  <ng-container *ngIf="requestInProgress || favoriteMelodies?.length > 0 else favoritesEmpty">
    <div class="songs-list">
      <div class="songs-list__item" *ngFor="let melody of favoriteMelodies" app-melody-item [melody]="melody"></div>
    </div>
  </ng-container>

  <app-mobile-apps-banner></app-mobile-apps-banner>
</div>

<ng-template #favoritesEmpty>
  <div class="page-notfound">
    <div class="page-notfound__img"></div>
    <div class="page-notfound__name h2">{{ 'subscriber-favorites-page.favorites-empty' | translate }}</div>
    <div class="page-notfound__text" [innerHtml]="'subscriber-favorites-page.favorites-empty-text' | translate"></div>
    <div class="page-notfound__button">
      <a routerLink="/genres" class="button">{{ 'subscriber-favorites-page.favorites-empty-catalog' | translate }}</a>
    </div>
  </div>
</ng-template>
